import { render, staticRenderFns } from "./thirdpartyform.component.vue?vue&type=template&id=6565bfb4"
import script from "./thirdpartyform.component.vue?vue&type=script&lang=js"
export * from "./thirdpartyform.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports